'use client'
import clsx from 'clsx'

import LoadingIndicator from 'shared/ui/LoadingIndicator/LoadingIndicator'

import { ClientOnlyPortal } from '../primitives/ClientOnlyPortal'

import styles from './LoadingOverlay.module.scss'

const LoadingOverlay = ({
  position = 'fixed'
}: {
  position?: 'fixed' | 'absolute'
}) => {
  const overlay = (
    <div
      className={clsx(styles.root, styles[position])}
      onClick={e => e.stopPropagation()}
    >
      <LoadingIndicator size={80} />
    </div>
  )

  if (position === 'fixed') {
    return (
      <ClientOnlyPortal selector='#overlay-portal'>{overlay}</ClientOnlyPortal>
    )
  }

  return overlay
}

export default LoadingOverlay
